module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feedItem panel bg-lightest black"
  }, [_c('div', {
    staticClass: "w-100 d-flex flex-row font-weight-600"
  }, [_c('div', {
    staticClass: "w-50"
  }, [_c('span', {
    staticClass: "ml-1"
  }, [_vm._v(_vm._s(_vm.weatherLabel) + " - " + _vm._s(_vm.windLabel))])]), _vm._v(" "), _c('div', {
    staticClass: "w-50 ml-5"
  }, [_c('span', {
    staticClass: "border-dark bg-light py-1 niceRadius pointer",
    on: {
      "click": _vm.toggleView
    }
  }, [_c('span', {
    staticClass: "py-1 px-3",
    class: {
      'bg-dark niceRadius lightest': _vm.selectedView == 'overview'
    }
  }, [_vm._v("Overview")]), _vm._v(" "), _c('span', {
    staticClass: "py-1 px-3",
    class: {
      'bg-dark niceRadius lightest': _vm.selectedView == 'details'
    }
  }, [_vm._v("Details")])])])]), _vm._v(" "), _c('div', {
    staticClass: "px-4 py-5 d-flex h-100"
  }, [_c('div', {
    staticClass: "w-50"
  }, [_c('div', {}, [_c('img', {
    staticClass: "align-middle",
    attrs: {
      "src": _vm.weatherIcon
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "temperatureDegrees align-middle font-weight-600"
  }, [_vm._v(_vm._s(_vm.temperature /*cardInfo.overview.temperature*/ ) + "º")])])]), _vm._v(" "), _c('div', {
    staticClass: "w-50 ml-5 darker"
  }, [_c('div', [_c('span', {
    staticClass: "font-weight-600"
  }, [_vm._v("Percipitation: ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.precipitation) + "mm")])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "font-weight-600"
  }, [_vm._v("Humidity: ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.humidity) + "%")])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "font-weight-600"
  }, [_vm._v("Wind: ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.windSpeed) + "km/h")])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "font-weight-600"
  }, [_vm._v("Location: ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.location))])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "font-weight-600"
  }, [_vm._v("Last update: ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lastUpdate))])])])]), _vm._v(" "), (_vm.selectedView == 'details') ? _c('div', {
    staticClass: "px-0 pt-5 d-flex windyContainer"
  }, [_c('iframe', {
    staticClass: "w-100 border-0",
    attrs: {
      "src": "https://embed.windy.com/embed2.html?lat=37.0902&lon=-8.2508&type=forecast&metricWind=kt&metricTemp=%C2%B0C"
    }
  })]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-42a3f582", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42a3f582"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/FeedcardWeather.vue
// module id = 1502
// module chunks = 0